// extracted by mini-css-extract-plugin
module.exports = {"Energy":"Energy_Energy__iWSBf"};